// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Signup_wrapper__FkV2D","textInput2":"Signup_textInput2__3PECP","tabItem":"Signup_tabItem__3x7Cs"};